import React, { useState } from 'react';
import { ChevronDown, HelpCircle, Music } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Es para TODOS los grados?',
  answer: 'SÍ. 4 secciones separadas: Preescolar, 1°-3°, 4°-6°, Repaso. Elige la tuya o usa todas si tienes diferentes grupos.'
}, {
  question: '¿Necesito saber música?',
  answer: 'NO. Escrito específicamente para maestros SIN formación musical. Si sabes música, mejor: amplificarás los resultados.'
}, {
  question: '¿Las canciones son mexicanas?',
  answer: 'SÍ. 40 canciones infantiles mexicanas tradicionales. Letra completa, fáciles de enseñar, tus alumnos las reconocen.'
}, {
  question: '¿Necesito materiales caros?',
  answer: 'NO. SOLO caseros: cucharas, botellas, telas, pañuelos. Si tienes dinero, perfecto. Si no: funciona igual.'
}, {
  question: '¿Se alinea con SEP?',
  answer: '100%. Cada plan cita el objetivo de aprendizaje esperado oficial. CUMPLES requisitos sin inventar criterios.'
}, {
  question: '¿Qué formato es?',
  answer: '1 PDF descargable. 60 páginas. Imprime lo que necesites. Cero enlaces externos, cero complicaciones.'
}, {
  question: '¿Puedo editar plantillas?',
  answer: 'SÍ. Todas editables en Word o PDF. Personaliza con tu nombre y escuela.'
}, {
  question: '¿Hay audios?',
  answer: 'No incluidos (ocuparía 100MB). Pero cada plan describe CÓMO enseñar la canción. Tú cantas, o busca en YouTube "La Marcha Conejito".'
}, {
  question: '¿Hay devolución?',
  answer: '30 días. Si no te encanta, devolvemos TODO sin preguntas. Sin explicaciones. Sin molestias.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-gray-50 py-12 md:py-20 px-4" data-id="element-89">
      <div className="max-w-3xl mx-auto" data-id="element-90">
        {/* Title */}
        <div className="text-center mb-10 md:mb-12" data-id="element-91">
          <p className="font-nunito font-bold text-orange-500 text-base md:text-lg uppercase tracking-widest mb-2 flex items-center justify-center gap-2" data-id="element-92">
            <HelpCircle className="w-5 h-5" data-id="element-93" /> Preguntas Frecuentes
          </p>
          <h2 className="font-nunito font-black text-gray-900 text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-94">
            OBJECIONES Y<span className="text-purple-700" data-id="element-95"> RESPUESTAS</span>
          </h2>
          <div className="flex items-center justify-center gap-3 mt-4" data-id="element-96">
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-97" />
            <Music className="w-6 h-6 text-orange-400" data-id="element-98" />
            <div className="h-1 w-16 bg-orange-400 rounded-full" data-id="element-99" />
          </div>
        </div>

        {/* FAQ accordion */}
        <div className="space-y-2 md:space-y-3" data-id="element-100">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-101">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between px-4 md:px-6 py-4 md:py-5 text-left hover:bg-orange-50 transition-colors" aria-expanded={openIndex === index} data-id="element-102">
                <span className="flex items-center gap-3 font-nunito font-bold text-gray-900 text-base md:text-lg pr-3 md:pr-4" data-id="element-103">
                  <HelpCircle className="w-5 h-5 text-purple-500 flex-shrink-0" data-id="element-104" />
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-purple-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-105" />
              </button>
              {openIndex === index && <div className="px-4 md:px-6 pb-4 md:pb-5" data-id="element-106">
                  <div className="h-px bg-gray-100 mb-3 md:mb-4" data-id="element-107" />
                  <p className="text-gray-700 font-semibold text-sm md:text-base leading-relaxed" data-id="element-108">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}